import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import HttpsRedirect from 'react-https-redirect';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { CssVarsPonyfill } from 'css-vars-ponyfill-react';

CssVarsPonyfill({
    externalStyleSheets: true,
    onError: error => {
        console.log(error);
    }
});

ReactDOM.render(
    <HttpsRedirect>
        <App />
    </HttpsRedirect>,
document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
